// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 3H2V11H22V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 13H2V21H22V13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-component-space-filled')
export default class ComponentSpaceFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-space-filled',
    }
  }
}
